import { createFileRoute } from "@tanstack/react-router";

import { IntakePage } from "../../pages/intake/Intake.page";

export const Route = createFileRoute("/_protected/intake")({
  component: IntakePage,
});
